import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Bulk upload moved to per-channel Channel Settings → General (Buffer-style),
 * so the standalone bulk page is retired. This route stays as a redirect so old
 * links/bookmarks keep working, landing on the Channels hub where each channel's
 * settings offer Bulk Upload.
 */
export const Route = createFileRoute("/(app)/bulk")({
  beforeLoad: () => {
    throw redirect({ to: "/channels", replace: true });
  },
});
